import React from "react";
import { makeStyles } from "@material-ui/core/styles";

import { Box } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import { notBlank } from "../util/ext";
import { join } from "ramda";

const useStyles = makeStyles(theme => ({
  labelAndValue: {
    "& label": {
      fontWeight: "bold",
      paddingRight: theme.spacing(2),
    },
  },
}));

const PapiAuthenticationCell = props => {
  const { authentication } = props;
  const classes = useStyles();

  return (
    <Grid container spacing={1}>
      <Grid item sm={8}>
        <Box className={classes.labelAndValue}>
          <label>Hostname:</label>
          {authentication.hostname}
        </Box>
      </Grid>

      {notBlank(authentication.port) && (
        <Grid item sm={4}>
          <Box className={classes.labelAndValue}>
            <label>Port:</label>
            {authentication.port}
          </Box>
        </Grid>
      )}

      {notBlank(authentication.prefixes) && (
        <Grid item sm={12}>
          <Box className={classes.labelAndValue}>
            <label>Barcode Prefixes:</label>
            {join(", ", authentication.prefixes)}
          </Box>
        </Grid>
      )}
    </Grid>
  );
};

export default PapiAuthenticationCell;
